export default __webpack_public_path__ + "static/media/trash-can-solid-space-cadet.ff39a4b3.png";